/*jshint esversion: 6 */
// Import analytics tracking
import './analytics';

jQuery(function ($) {

  // Add necessary parameters to YouTube Thickbox links
  $('a.thickbox').each(function () {
    const href = $(this).attr('href');
    if (href && href.includes('youtube.com')) {
      const separator = href.includes('?') ? '&' : '?';
      const origin = encodeURIComponent(window.location.origin);
      $(this).attr('href', href + separator + 'rel=0&autoplay=1&TB_iframe=true&enablejsapi=1&origin=' + origin);
    }
  });

  // width required for pseudo element placement
  $(window).on('load', function () {
    $('.is-style-text-link').each(function () {
      const btn = $(this).find('.wp-element-button');
      btn.css('min-width', this.offsetWidth + 20 + 'px');
      $(this).addClass('has-pseudo');
    });
  });

  // Create loading overlay if it doesn't exist
  if (!$('#loading-overlay').length) {
    $('body').append(`
      <div id="loading-overlay" style="display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
           background: rgba(255, 255, 255, 0.8); z-index: 9999; justify-content: center; align-items: center;">
        <i class="fa-solid fa-spinner fa-spin fa-3x" style="color: #0067be;"></i>
        <span class="sr-only">Loading...</span>
      </div>
    `);
  }

  // Dropdown Selector
  $('select.dropdown-selector').on('change', function () {
    const selectedValue = $(this).val();
    if (selectedValue) {
      const form = $(this).closest('form');
      const action = form.data('form-action') || form.attr('action');
      const url = action.endsWith('/') ? action : action + '/';
      form.attr('action', url + selectedValue);
      
      // Show loading overlay
      $('#loading-overlay').css('display', 'flex');
      
      // Submit form and handle completion
      form.one('submit', function() {
        setTimeout(function() {
          $('#loading-overlay').hide();
        }, 5000); // Hide overlay after 5s in case of error
      });
      form.submit();
    }
  });

  // Lazy load videos and fix YouTube origin issues
  $('iframe').each(function() {
    // Add lazy loading
    $(this).attr('loading', 'lazy');
  });

});

// Control YouTube video playback -- stop videos when another is playing or slick slider changes
// https://developers.google.com/youtube/iframe_api_reference
// Only load YouTube API if there are YouTube videos on the page
if (document.querySelector('iframe[src*="youtube.com"]') || document.querySelector('a.thickbox[href*="youtube.com"]')) {
  var tag = document.createElement("script");
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName("script")[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}
